import useAutoCenter from '/druid/hooks/internal/useAutoCenter';

const AutoCenter = () => {
  useAutoCenter();

  return false;
};

export default AutoCenter;
